(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mairaz-hero"] && !Shopify.designMode) return;
  try {
    
class MairazHero {
  constructor(root) {
    this.root = root;
    this.slidesEl = root.querySelector('[data-mrz-hero-slides]');
    this.slides = Array.from(root.querySelectorAll('[data-mrz-hero-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-mrz-hero-dot]'));
    this.toggleEl = root.querySelector('[data-mrz-hero-toggle]');
    this.progressEl = root.querySelector('[data-mrz-hero-progress]');

    if (this.slides.length < 2) return;

    this.index = 0;
    this.duration = parseInt(root.dataset.rotate, 10) || 7000;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.canAuto = root.dataset.autorotate === 'true';
    this.wantsPlay = this.canAuto && !this.reduceMotion;

    this.hovering = false;
    this.focused = false;
    this.rafId = null;
    this.last = null;
    this.elapsed = 0;

    this.tick = this.tick.bind(this);
    this.sync = this.sync.bind(this);

    this.bind();
    this.sync();
  }

  bind() {
    const prev = this.root.querySelector('[data-mrz-hero-prev]');
    const next = this.root.querySelector('[data-mrz-hero-next]');

    if (prev) prev.addEventListener('click', () => this.step(-1));
    if (next) next.addEventListener('click', () => this.step(1));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
    });

    if (this.toggleEl) {
      this.toggleEl.addEventListener('click', () => {
        this.wantsPlay = !this.wantsPlay;
        if (this.wantsPlay) this.elapsed = 0;
        this.sync();
      });
    }

    this.root.addEventListener('mouseenter', () => { this.hovering = true; this.sync(); });
    this.root.addEventListener('mouseleave', () => { this.hovering = false; this.sync(); });
    this.root.addEventListener('focusin', () => { this.focused = true; this.sync(); });
    this.root.addEventListener('focusout', (event) => {
      if (this.root.contains(event.relatedTarget)) return;
      this.focused = false;
      this.sync();
    });

    document.addEventListener('visibilitychange', this.sync);

    this.root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
    });

    let startX = 0;
    let startY = 0;

    this.slidesEl.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
    }, { passive: true });

    this.slidesEl.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      this.step(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  get isRunning() {
    return this.root.isConnected && this.canAuto && this.wantsPlay && !this.hovering && !this.focused && !document.hidden;
  }

  sync() {
    if (this.isRunning) {
      this.last = null;
      if (this.rafId === null) this.rafId = requestAnimationFrame(this.tick);
    } else if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    const playing = this.canAuto && this.wantsPlay;
    this.root.classList.toggle('is-paused', !playing);

    if (this.slidesEl) {
      this.slidesEl.setAttribute('aria-live', this.isRunning ? 'off' : 'polite');
    }

    if (this.toggleEl) {
      this.toggleEl.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
      if (!playing && this.progressEl) this.progressEl.style.transform = 'scaleX(0)';
    }
  }

  tick(now) {
    this.rafId = null;
    if (!this.isRunning) return;

    if (this.last === null) this.last = now;
    this.elapsed += now - this.last;
    this.last = now;

    const ratio = Math.min(this.elapsed / this.duration, 1);
    if (this.progressEl) this.progressEl.style.transform = 'scaleX(' + ratio + ')';

    if (ratio >= 1) {
      this.step(1);
      return;
    }

    this.rafId = requestAnimationFrame(this.tick);
  }

  step(delta) {
    this.go(this.index + delta);
  }

  go(target) {
    const count = this.slides.length;
    const next = ((target % count) + count) % count;

    this.elapsed = 0;
    this.last = null;
    if (this.progressEl) this.progressEl.style.transform = 'scaleX(0)';

    if (next !== this.index) {
      this.slides[this.index].classList.remove('is-active');
      this.slides[next].classList.add('is-active');

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === next);
        if (i === next) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      this.index = next;
    }

    this.sync();
  }
}

function mairazHeroInit(scope) {
  const root = scope || document;
  root.querySelectorAll('[data-mrz-hero]').forEach((el) => {
    if (el.dataset.mrzHeroReady === 'true') return;
    el.dataset.mrzHeroReady = 'true';
    new MairazHero(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => mairazHeroInit());
} else {
  mairazHeroInit();
}

document.addEventListener('shopify:section:load', (event) => mairazHeroInit(event.target));

  } catch(e) { console.error(e); }
})();
})();
